import { fetchWithCache, getCachedData } from "../services/apiService";

export const advertiseProfile = async (setProfiles) => {
  // Show cached data immediately if available
  const cached = getCachedData(
    "/api/advertisement/advertisementGrabProfile",
    {},
  );
  if (cached) {
    setProfiles(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/advertisement/advertisementGrabProfile",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    if (Array.isArray(data) && data.length > 0) {
      setProfiles(data);
    } else if (!cached) {
      setProfiles([]);
    }
  } catch (error) {
    if (!cached) {
      setProfiles([]);
    }
  }
};
